$(document).ready(function() {
    $(document).on('click', '.toggle-question', function () {
        const question = (this).getAttribute('data-question-id');
        const value = (this).getAttribute('value');
        const toggleItem = $(`.questionData_${question}`);

        if (toggleItem != null && question != null) {
            if (value === 'false') {
                $(`#show_question_${question}`).prop('checked', false);
                $(`#hide_question_${question}`).prop('checked', true);
                toggleItem.addClass('d-none');
            } else {
                $(`#show_question_${question}`).prop('checked', true);
                $(`#hide_question_${question}`).prop('checked', false);
                toggleItem.removeClass('d-none');
            }

            storeQuestionToggle(
                question,
                $(`#file_manager_questionnaire`).attr('data-folder-id'),
                value !== 'false'
            )
        }
    });

    function storeQuestionToggle(question, folder, toggle) {
        axios.post(`/api/questionnaires/${question}/toggle`,
            {'toggle': toggle, 'question_id': question, 'folder_id' : folder})
            .catch(function (error) {
                console.log(error);
            });
    }
});
